import styles from './index.module.less';
import { useTranslation } from 'next-i18next';

export default function SectionWho() {
  const { t } = useTranslation();

  // 文案内容对象
  const contentData = {
    title: t('Why Choose Erasa?'),
    cards: [
      {
        id: 'Fast-Efficient',
        icon: '⚡️',
        title: t('Fast & Efficient'),
        description: t('Get leaks removed within 24–72 hours with Erasa’s fast response.'),
      },
      {
        id: '13-Years-of-Experience',
        icon: '🎖️',
        title: t('13 Years of Experience'),
        description: t('13 years of experience in protecting valuable content and brand identity.'),
      },
      {
        id: 'Comprehensive-Protection',
        icon: '🛡️',
        title: t('Comprehensive Protection'),
        description: t(
          'Erasa covers all major platforms like OnlyFans, Instagram, and more to safeguard your content.',
        ),
      },
      {
        id: 'High-Removal-Rate',
        icon: '📈',
        title: t('High Removal Rate'),
        description: t('Our experts and advanced technology ensure an average removal rate of 90%.'),
      },
    ],
  };
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{contentData.title}</h2>
      <div className={styles.cardsGrid}>
        {contentData.cards.map((card) => (
          <div key={card.id} className={styles.card}>
            <div className={styles.iconWrapper}>
              <span className={styles.icon}>{card.icon}</span>
            </div>
            <div className={styles.cardContent}>
              <h3 className={styles.cardTitle}>{card.title}</h3>
              <p className={styles.cardDescription}>{card.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
